import * as helpers from './helpers'

const defaultListReducerForAtradnesVesture = helpers.createListReducer({listViewName: 'audit_list_for_atradne'})
const defaultListReducerForAtradnesVestureIerobezoti = helpers.createListReducer({listViewName: 'audit_list_for_atradne_ierobezoti'})
export const atradnesVesture = (state = helpers.listGetInitialState(), action) => {
    const {type} = action
    if (type.startsWith('audit_list_for_atradne_ierobezoti')) {
        return defaultListReducerForAtradnesVestureIerobezoti({...action, state})
    }
    return defaultListReducerForAtradnesVesture({...action, state})
}

const defaultListReducerForAudits = helpers.createListReducer({listViewName: 'audit_list'})
export const audits = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here
    return defaultListReducerForAudits({state, type, payload, reqId})
}

const defaultListReducerForAtradnesDalaVesture = helpers.createListReducer({listViewName: 'audit_list_for_atradnes_dala'})
export const atradnesDalasVesture = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here
    return defaultListReducerForAtradnesDalaVesture({state, type, payload, reqId})
}

const defaultListReducerForAuditsAtradnesAtskaite = helpers.createListReducer({listViewName: 'audit_stats_by_atradne'})
export const auditStatsByAtradne = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here
    return defaultListReducerForAuditsAtradnesAtskaite({state, type, payload, reqId})
}

const defaultListReducerForPersonasDatuAudits = helpers.createListReducer({listViewName: 'personas_datu_audit_list'})
export const personasDatuAudits = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here
    return defaultListReducerForPersonasDatuAudits({state, type, payload, reqId})
}